import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Container,
  Alert,
  CircularProgress,
  IconButton,
  Link,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstance from './axiosInstance';

function Login() {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await axiosInstance.post('/token/', formData);
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);

      const userResponse = await axiosInstance.get('/me/');
      localStorage.setItem('user', JSON.stringify(userResponse.data));

      window.location.href = '/';
    } catch (error) {
      console.error('Login error:', error);
      let errorMessage = 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.';
      if (error.response?.status === 401) {
        errorMessage = 'Benutzername oder Passwort ist falsch.';
      } else if (error.response?.status === 400) {
        errorMessage = 'Bitte Benutzername und Passwort eingeben.';
      } else if (!error.response) {
        errorMessage = 'Server nicht erreichbar. Bitte später erneut versuchen.';
      }
      setError(errorMessage);
      setIsLoading(false);
    }
  };

  const handleCloseError = () => setError('');

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 5 },
            width: '100%',
            border: (t) => `1px solid ${t.palette.divider}`,
            boxShadow: '0 10px 40px rgba(14,26,43,.08)',
          }}
        >
          {/* Kinflow-Wortmarke */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, justifyContent: 'center', mb: 3 }}>
            <Box sx={{ width: 14, height: 14, borderRadius: '50%', bgcolor: 'secondary.main' }} />
            <Typography component="span" sx={{ fontWeight: 800, fontSize: '2rem', letterSpacing: '-0.02em', lineHeight: 1, color: 'text.primary' }}>
              Kin<Box component="span" sx={{ color: 'primary.main' }}>flow</Box>
            </Typography>
          </Box>

          <Typography variant="h5" component="h1" align="center" sx={{ fontWeight: 700 }}>
            Willkommen zurück
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1, mb: 3 }}>
            Melde dich an, um fortzufahren.
          </Typography>

          {error && (
            <Alert
              severity="error"
              sx={{ width: '100%', mb: 2, '& .MuiAlert-action': { alignItems: 'center' } }}
              action={
                <IconButton aria-label="Schließen" color="inherit" size="small" onClick={handleCloseError}>
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }} noValidate>
            <TextField
              margin="normal" required fullWidth
              id="username" label="Benutzername" name="username"
              autoComplete="username" autoFocus
              value={formData.username} onChange={handleChange}
              disabled={isLoading} error={!!error}
            />
            <TextField
              margin="normal" required fullWidth
              name="password" label="Passwort" type="password" id="password"
              autoComplete="current-password"
              value={formData.password} onChange={handleChange}
              disabled={isLoading} error={!!error}
            />
            <Button
              type="submit" fullWidth variant="contained" size="large"
              sx={{ mt: 3, mb: 1 }} disabled={isLoading}
            >
              {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Anmelden'}
            </Button>
            <Box sx={{ textAlign: 'center', mt: 1 }}>
              <Link component={RouterLink} to="/forgot-password" variant="body2" underline="hover">
                Passwort vergessen?
              </Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default Login;
